import styled from 'styled-components'

export const StyledData = styled.div`
    color: ${({ theme }) => theme.greyishBrown};
`

export const StyledTime = styled.div`
    color: ${({ theme }) => theme.brownGrey};
    letter-spacing: 0.44px;
`
